<div *ngIf="!workflow">
	<nz-page-header nzTitle="Loading workflow..."></nz-page-header>
</div>

<div class="p-4" *ngIf="workflow">
	<nz-page-header [nzTitle]="workflow.name"></nz-page-header>
	<nz-divider></nz-divider>

	<div *ngIf="!ticketReport.id || ticketReport.id < 0">
		<form nz-form [formGroup]="form">
			<nz-form-item>
				<nz-form-label [nzSpan]="4" nzFor="name">Report Name</nz-form-label>
				<nz-form-control [nzSpan]="8">
					<input nz-input formControlName="name" id="name" />
				</nz-form-control>
			</nz-form-item>

			<nz-form-item>
				<nz-form-label [nzSpan]="4" nzFor="description">Description</nz-form-label>
				<nz-form-control [nzSpan]="8">
					<textarea nz-input formControlName="description" id="description"></textarea>
				</nz-form-control>
			</nz-form-item>

			<nz-form-item>
				<nz-form-control [nzSpan]="8" [nzOffset]="4">
					<button nz-button nzType="primary" (click)="onCreate()">Create</button>
				</nz-form-control>
			</nz-form-item>
		</form>
	</div>


	<div *ngIf="ticketReport.id && ticketReport.id >= 0">
		<form nz-form [formGroup]="form">
			<div nz-row [nzGutter]="16">
				<div nz-col [nzSpan]="24">
					<nz-form-item>
						<nz-form-label [nzSpan]="2" nzFor="name">Report Name</nz-form-label>
						<nz-form-control [nzSpan]="14">
							<input nz-input formControlName="name" id="name" />
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-label [nzSpan]="2"
							nzFor="description">Description</nz-form-label>
						<nz-form-control [nzSpan]="14">
							<textarea nz-input formControlName="description"
								id="description"></textarea>
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-label [nzSpan]="2" nzFor="sqlQuery">SQL Query</nz-form-label>
						<nz-form-control [nzSpan]="22">
							<ngx-monaco-editor [options]="editorOptions"
								formControlName="sqlQuery"
								style="height: 800px; width: 100%; display: block;">
							</ngx-monaco-editor>
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-control [nzSpan]="2" [nzOffset]="2">
							<button nz-button nzType="primary"
								(click)="onSave()">Save</button>
						</nz-form-control>
					</nz-form-item>
				</div>
			</div>

			<nz-divider></nz-divider>
			<h4>Preview</h4>
			<div nz-row [nzGutter]="16">
				<div nz-col [nzSpan]="24">
					<button class="float-end ms-2" nz-button nzType="primary"
						(click)="fetchPreview()">Refresh</button>
					<button class="float-end ms-2" nz-button nzType="primary"
						(click)="doDownload()">Download</button>
					<nz-form-item class="float-end">
						<nz-form-label nzFor="date">Date Filter</nz-form-label>
						<nz-form-control>
							<nz-date-picker formControlName="date"></nz-date-picker>
						</nz-form-control>
					</nz-form-item>
				</div>
			</div>
			<nz-table #table [nzData]="previewData.rows" nzBordered [nzShowPagination]="false"
				[nzBordered]="true" [nzLoading]="loading"
				*ngIf="previewData && previewData.columnTitles && previewData.columnTitles.length != 0">
				<thead>
					<tr>
						<th *ngFor="let column of previewData.columnTitles">
							{{column}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of previewData.rows">
						<td *ngFor="let column of row.cells">{{column.value}}</td>
					</tr>
				</tbody>
			</nz-table>
		</form>
	</div>
</div>